'use strict';

wbApp.factory('referenceSourceSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var ReferenceSource = $resource('/Api/ReferenceSource/Get/:id', {}, {
            'query': { method: 'GET', isArray: true },
            'insert': { method: 'POST', url: '/Api/ReferenceSource/Insert' },
            'update': { method: 'POST', url: '/Api/ReferenceSource/Update' },
            'delete': { method: 'POST', url: '/Api/ReferenceSource/Delete' },
            'getReferenceSourceTimeDevelopment': { method: 'GET', url: '/Api/ReferenceSource/GetReferenceSourceTimeDevelopment', isArray: false },

        });

        var referenceSource = null;
        var referenceSourceDict = null;

        function getAllAsync(refresh) {
            if (!referenceSource || refresh) {
                referenceSource = repositorySvc.get(ReferenceSource, {});
                referenceSourceDict = null;
            }

            return referenceSource;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                ReferenceSource,   // $resource
                referenceSource,   // collection
                data,              // entity
                success,
                errorCallback);

            function success(successResult) {
                if (!!referenceSourceDict) {
                    referenceSourceDict[successResult.id] = successResult;
                }

                if (!!successCallback) {
                    successCallback(successResult)
                }
            }
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                ReferenceSource,   // $resource
                referenceSource,   // collection
                data,              // entity
                success,
                errorCallback);

            function success(successResult) {
                if (!!referenceSourceDict) {
                    referenceSourceDict[successResult.id] = successResult;
                }

                if (!!successCallback) {
                    successCallback(successResult)
                }
            }
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                ReferenceSource,   // $resource
                referenceSource,   // collection
                data,              // entity
                success,              // successCallback
                errorCallback);

            function success() {
                if (!!referenceSourceDict) {
                    delete referenceSourceDict[data.id];
                }
            }
        }

        function get(id) {
            if (referenceSource) {
                if (!referenceSourceDict) {
                    referenceSourceDict = {};
                    angular.forEach(referenceSource, function (value, key) {
                        this[value.id] = value;
                    }, referenceSourceDict);
                }

                return referenceSourceDict[id];

            } else {
                return null;
            }
        }

        function getReferenceSourceTimeDevelopment(fromDate, toDate) {
            var deffered = $q.defer();

            var td = repositorySvc.customGet(
                    'getReferenceSourceTimeDevelopment',
                    ReferenceSource,
                    {
                        fromDate: fromDate,
                        toDate: toDate
                    });

            td.$promise.then(function (data) {
                    
                var cols = [];
                cols.push({
                    id: 'date',
                    label: 'Date',
                    type: 'date',
                    p: {}
                });

                for(var i = 0; i < data.referenceSources.length; i++) {
                    var rs = data.referenceSources[i];
                    cols.push({
                        id: 'c_' + i,
                        label: rs.name,
                        type: 'number',
                        p: {}
                    });
                }

                var rows = [];
                for (var d = 0; d < data.days.length; d++) {
                    var day = data.days[d];
                    var o = {
                        c: [
                            { v: day.day }
                        ]
                    };

                    for (var c = 0; c < day.counts.length; c++) {
                        o.c.push({ v: day.counts[c] });
                    }

                    rows.push(o);
                }

                deffered.resolve({
                    cols: cols,
                    rows: rows
                });
            }, function (reason) {
                deffered.reject(reason);
            });

            return deffered.promise;
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            get: get,
            getReferenceSourceTimeDevelopment: getReferenceSourceTimeDevelopment
        }
    }]);
